import { isEqual } from 'lodash-es';

import { useStoreSelector } from '../../../core/store/selector.js';
import { HoneycombStoreContext } from '../context/honeycomb-store.context.js';
import { HoneycombState } from '../types/state.js';

export const useSelector = <T>(selector: (state: HoneycombState) => T): T =>
  useStoreSelector(HoneycombStoreContext, selector, isEqual);

export const useHoneycombTooltipState = () =>
  useSelector((state: HoneycombState) => {
    const { pinned, ...tooltipState } = state.tooltip;

    return tooltipState;
  });

export const useHoneycombTooltipPinnedState = () =>
  useSelector((state: HoneycombState) => state.tooltip.pinned);

export const useHoneycombSelectionState = () =>
  useSelector((state: HoneycombState) => state.selection);

export const useHoneycombOverlayMouseInBoundsState = () =>
  useSelector((state: HoneycombState) => {
    const { mouseInBounds } = state.overlay;
    return mouseInBounds;
  });
